export default "__VITE_ASSET__0f432dad__"